import { render } from "./ProgressBarComponent.vue?vue&type=template&id=18aa6130"
import script from "./ProgressBarComponent.vue?vue&type=script&lang=js"
export * from "./ProgressBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__